import React, { Component } from "react";
import { Card } from "react-bootstrap-v5";

class CostBreakdownSummary extends Component {
  render() {
    const { jobData } = this.props;

    const keyMap = {
      AIR: "quote_request_airs",
      COURIER: "quote_request_couriers",
      LAND: "quote_request_lands",
      SEA: "quote_request_seas",
    };

    const serviceType = jobData?.shipment_details?.servic_type || "";
    const match = Object.keys(keyMap).find((type) =>
      serviceType.includes(type)
    );
    const matchedKey = match ? keyMap[match] : null;
    const quoteData = jobData?.[matchedKey] || {};
    const breakdown = quoteData?.breakdown;
    
    // Find delivery breakdown based on shipment mode
    const isPort = jobData?.shipment_details?.shipment_mode?.includes("PORT");
    const isDoor = jobData?.shipment_details?.shipment_mode?.includes("DOOR");
    
    let activeBreakdown = null;
    if (isPort && breakdown?.port_delivery) activeBreakdown = breakdown.port_delivery;
    else if (isDoor && breakdown?.door_delivery) activeBreakdown = breakdown.door_delivery;
    else if (breakdown?.port_delivery) activeBreakdown = breakdown.port_delivery;
    else if (breakdown?.door_delivery) activeBreakdown = breakdown.door_delivery;

    const dutyTaxArray = activeBreakdown?.additional_charges?.dutyTax || [];
    const dutyTaxItem = dutyTaxArray[0] || {};

    const goodValue = jobData?.shipment_details?.value_of_goods;
    const freight = dutyTaxItem.freight !== undefined ? dutyTaxItem.freight : activeBreakdown?.freight_amnount;
    const dutyTax = dutyTaxItem.duty !== undefined ? dutyTaxItem.duty : dutyTaxItem.total_duty_tax;
    const insurance = dutyTaxItem.insurance;

    const costs = [
      { label: "Value of Goods", value: goodValue },
      { label: "Freight", value: freight },
      { label: "Duty Tax", value: dutyTax },
      { label: "Insurance", value: insurance },
    ];

    const availableCosts = costs.filter(c => c.value !== undefined && c.value !== null && c.value !== "");

    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Cost Breakdown Summary</h4>
        </div>
        <Card.Body>
          {availableCosts.length > 0 ? (
            <div
              className="col-sm-6"
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "16px",
                backgroundColor: "#fafafa",
              }}
            >
              <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                {availableCosts.map((cost, idx) => (
                  <li key={idx} style={{ marginBottom: "8px", display: "flex", justifyContent: "space-between", borderBottom: idx !== availableCosts.length - 1 ? "1px solid #eee" : "none", paddingBottom: idx !== availableCosts.length - 1 ? "8px" : "0" }}>
                    <span style={{ fontWeight: "bold", color: "#555" }}>{cost.label}:</span>
                    <span style={{ color: cost.value === 0 ? "#888" : "#000", fontWeight: "600" }}>{cost.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <div className="text-center p-3 text-muted">Data not available</div>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default CostBreakdownSummary;
